import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { AppDrawer } from "../../shared/AppDrawer";
import { Confirmation } from "../../shared/Confirmation";
import { TeamDrawerFormContent } from "./TeamDrawerFormContent";
export const TeamDrawer = ({ userId, opened, close }) => {
    // State
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    // Handlers
    const handleDirtyChange = useCallback((dirty) => {
        setIsDirty(dirty);
    }, []);
    const handleClose = () => {
        if (isDirty) {
            setConfirmOpen(true);
        }
        else {
            close();
        }
    };
    const handleConfirmLeave = async () => {
        setConfirmOpen(false);
        setIsDirty(false);
        close();
    };
    return (_jsxs(_Fragment, { children: [_jsx(AppDrawer, { withCloseButton: false, size: "32rem", opened: opened, onClose: handleClose, stackId: "team", children: _jsx(TeamDrawerFormContent, { userId: userId, active: opened, onSuccess: close, onDirtyChange: handleDirtyChange }) }), _jsx(Confirmation, { action: "leave", additionalText: "You have unsaved changes that won't be saved.", opened: confirmOpen, close: () => setConfirmOpen(false), handleAction: handleConfirmLeave })] }));
};
